const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      name: '田中 美咲様',
      pet: '愛犬ポチ（ゴールデンレトリバー・12歳）',
      service: '個別火葬・個別納骨',
      comment:
        '12年間家族として過ごしたポチとのお別れは本当に辛かったですが、スタッフの皆様が温かく寄り添ってくださり、心を込めて見送ることができました。立ち会い火葬で最後まで一緒にいられたことが何よりの救いでした。',
      image:
        'https://public.readdy.ai/ai/img_res/562d897535d539403d651c19c9eee369.jpg',
      rating: 5,
    },
    {
      id: 2,
      name: '佐藤 健太様',
      pet: '愛猫ミケ（三毛猫・15歳）',
      service: '個別火葬・遺骨返却',
      comment:
        '15年間一緒に暮らしたミケが亡くなり、どうしていいかわからない中、丁寧に対応していただきました。施設も清潔で、スタッフの方々の心遣いが素晴らしかったです。今は自宅の仏壇で供養しています。',
      image:
        'https://readdy.ai/api/search-image?query=A%20portrait%20of%20a%20sincere%20Japanese%20man%20in%20his%2050s%20with%20a%20calm%20expression%2C%20gentle%20and%20thoughtful%20demeanor%2C%20soft%20natural%20lighting%2C%20simple%20clean%20background%2C%20professional%20photography%20style%2C%20photorealistic%2C%20high%20quality&width=400&height=400&seq=testimonial-2&orientation=squarish',
      rating: 5,
    },
    {
      id: 3,
      name: '山本 由美子様',
      pet: '愛鳥ピーちゃん（セキセイインコ・8歳）',
      service: '個別火葬・合同納骨',
      comment:
        '小さなインコでも丁寧に対応していただき、感謝しています。小動物だからと諦めていましたが、こちらでは小鳥も大切に扱ってくださいました。合同納骨で他のペットたちと一緒に眠れることも安心です。',
      image:
        'https://readdy.ai/api/search-image?query=A%20portrait%20of%20a%20gentle%20Japanese%20woman%20in%20her%2030s%20with%20a%20warm%20smile%2C%20kind%20and%20caring%20expression%2C%20soft%20natural%20lighting%2C%20simple%20clean%20background%2C%20professional%20photography%20style%2C%20photorealistic%2C%20high%20quality&width=400&height=400&seq=testimonial-3&orientation=squarish',
      rating: 5,
    },
    {
      id: 4,
      name: '鈴木 誠様',
      pet: '愛犬チョコ（トイプードル・10歳）',
      service: '個別火葬・個別納骨',
      comment:
        '突然のお別れで動揺していましたが、24時間対応していただき本当に助かりました。納骨室も美しく、定期的にお参りに来ています。スタッフの皆様の優しさに心から感謝しております。',
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/abe852ef421be38fa3dce1ea65a3c7bc.jpeg',
      rating: 5,
    },
  ];

  return (
    <section className="py-16 sm:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-gray-800 mb-3">
            お客様の声
          </h2>
          <p className="text-base text-gray-600">
            ご利用いただいたお客様からのメッセージ
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="flex flex-col items-center mb-6">
                <div className="w-20 h-20 rounded-full overflow-hidden mb-4 bg-gradient-to-br from-purple-200 to-pink-200">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex gap-1 mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i
                      key={i}
                      className="ri-star-fill text-purple-400 text-lg"
                    ></i>
                  ))}
                </div>
              </div>

              <div className="relative mb-6">
                <i className="ri-double-quotes-l text-3xl text-purple-200 absolute -top-2 -left-2"></i>
                <p className="text-base text-gray-700 leading-relaxed px-4">
                  {testimonial.comment}
                </p>
                <i className="ri-double-quotes-r text-3xl text-purple-200 absolute -bottom-2 -right-2"></i>
              </div>

              <div className="text-center border-t border-gray-100 pt-4">
                <p className="text-lg font-bold text-gray-800 mb-1">
                  {testimonial.name}
                </p>
                <p className="text-sm text-gray-600 mb-1">{testimonial.pet}</p>
                <p className="text-xs text-gray-500">{testimonial.service}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
